export default theme => ({
  mainContainer: {
    paddingTop: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(7),
    },
  },
});
